export function agentEditorContext(params: URLSearchParams) {
    const runId = params.get('agentRun');
    const stepId = params.get('agentStep');
    const revisionText = params.get('agentRevision');
    if (!runId || !stepId || revisionText === null || !/^\d+$/.test(revisionText))
        return null;
    const revision = Number(revisionText);
    return Number.isSafeInteger(revision) ? { runId, stepId, revision } : null;
}
